const LearningObjectiveCard = ({ objectives }) => {
  return (
    <div className="card mb-4 bg-gradient-glass backdrop-filter-20px border-common">
      <div className="card-body p-4">
        <h5 className="text-white fw-bold mb-3">🎯 Learning Objectives</h5>
        <div className="row">
          {objectives && objectives.length > 0 ? (
            objectives.map((obj, index) => (
              <div className="col-md-6 mb-3" key={index}>
                <div className="d-flex align-items-start">
                  <span className="badge rounded-pill me-3 mt-1 bg-gradient-success">
                    {index + 1}
                  </span>
                  <span className="text-white">{obj}</span>
                </div>
              </div>
            ))
          ) : (
            <p className="text-white-50">No objectives available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LearningObjectiveCard;
